import { ParsedDate } from '../parsed/parsedDate';
import { z } from 'zod';

export const AdReactionType = z.enum(['seen', 'seenDetails', 'closed', 'swipedAway', 'timeout', 'error']);
export type AdReactionType = z.infer<typeof AdReactionType>;

export const AdReaction = z.object({
    reactionGuid: z.string(),
    advertisementGuid: z.string(),
    seenOn: ParsedDate,
    reaction: AdReactionType,
    interacted: z.boolean(),
    durationSeen: z.number(),
    iterations: z.number(),
    swiped: z.boolean().optional(),
    enlarged: z.boolean().optional(),
    closed: z.boolean().optional(),
    added: z.boolean().optional(),
});
export type AdReaction = z.infer<typeof AdReaction>;
